export default "__VITE_ASSET__DtSD0RuZ__"